var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRebates = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 89 81",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Icon / Rebates")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Custom-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Keynote-Slide",
    transform: "translate(-703.000000, -799.000000)",
    fill: "#F5F5F5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Rebates",
    transform: "translate(703.220700, 799.794450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2842,40.97075 C54.0282,41.12175 53.7412,41.19475 53.4522,41.19475 C53.1692,41.19475 52.8802,41.11775 52.6202,40.97075 C52.1082,40.67475 51.7922,40.12275 51.7922,39.53175 L51.7922,30.71375 L1.6642,30.71375 C0.7462,30.71375 0.0002,29.97075 0.0002,29.05075 L0.0002,12.13975 C0.0002,11.22175 0.7462,10.47675 1.6642,10.47675 L51.7922,10.47675 L51.7922,1.65875 C51.7922,1.06675 52.1082,0.51975 52.6202,0.22275 C53.1362,-0.07425 53.7682,-0.07425 54.2842,0.22275 L87.0772,19.15875 C87.5932,19.45375 87.9092,20.00275 87.9092,20.59875 C87.9092,21.19175 87.5932,21.74075 87.0772,22.03575 L54.2842,40.97075 Z M33.624,38.71875 C33.88,38.56875 34.169,38.49575 34.456,38.49575 C34.741,38.49575 35.028,38.57275 35.288,38.71875 C35.8,39.01575 36.116,39.56675 36.116,40.15875 L36.116,48.97675 L86.245,48.97675 C87.163,48.97675 87.909,49.71875 87.909,50.63975 L87.909,67.54975 C87.909,68.46775 87.163,69.21375 86.245,69.21375 L36.116,69.21375 L36.116,78.03175 C36.116,78.62375 35.8,79.17075 35.288,79.46775 C34.772,79.76475 34.14,79.76475 33.624,79.46775 L0.832,60.53175 C0.316,60.23675 8.52651283e-14,59.68775 8.52651283e-14,59.09175 C8.52651283e-14,58.49875 0.316,57.94975 0.832,57.65375 L33.624,38.71875 Z",
    id: "Combined-Shape"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRebates, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Rebates.1b589609.svg";
export { ForwardRef as ReactComponent };